var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.655 5.17 2 1l11.922 30 16.613-20.24-5.88-5.59zm-.365 1.836 3.466 3.294-9.479 1.716 6.013-5.01zm-8.07 4.667L6.228 3.387l16.327 3.005-6.338 5.28zm-.713 1.465L13.88 26.605 5.094 4.502l10.412 8.636zm1.508.715 10.495-1.9L15.472 26.62l1.543-12.767z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtrx);
export default __webpack_public_path__ + "static/media/WTRX.1a33a13e2a9d7cb8805f515d60c311a5.svg";
export { ForwardRef as ReactComponent };